<div
  data-cy="cart-item-instance"
  class="flex justify-around items-center -mr-3 px-2 py-1 border-gray-300 border-b w-full max-w-full min-height-12">
  <div class="w-full">
    <div
      class="flex justify-between items-center w-full"
      [ngClass]="{
        'mb-2': isTicketFeeEnabled,
      }">
      <div class="flex justify-center items-center gap-4">
        <h5
          class="flex flex-wrap justify-center content-center md:ml-2 font-bold">
          <span class="mr-1 font-normal text-gray-600">Section</span>
          <span data-cy="cart-section-name">{{ sectionName }}</span>
        </h5>
        <div
          class="flex justify-center items-center"
          [ngClass]="{
            'gap-2': isTicketFeeEnabled,
            'flex-wrap md:flex-nowrap': !isTicketFeeEnabled,
          }">
          <div
            class="flex justify-center items-center ml-3 px-3 md:px-4 border border-gray-300 rounded-full w-25 min-w-max h-8">
            <img
              src="/assets/img/chair-blue-icon.svg"
              alt="main chair icon"
              class="h-3" />
            <h5 class="ml-1 min-w-max font-bold text-main">
              {{ data.totalSectionSeats }} seats
            </h5>
          </div>
          <ng-container>
            @if (!isTicketFeeEnabled || !data.totalSectionPriceWithFee) {
              <div class="ml-3 md:ml-5">
                <h5 class="font-bold text-main">
                  ${{ data.totalSectionPrice | number: '1.2-2' }}
                </h5>
              </div>
            }
          </ng-container>
        </div>
      </div>
      <div class="flex ml-1">
        <button
          class="bg-white hover:bg-gray-200 disabled:opacity-30 ml-1 disabled:hover:transform-none hover:scale-95 transition-transform btn-icon"
          (click)="removeSection()">
          <img src="/assets/img/delete-bin-icon.svg" alt="delet bin icon" />
        </button>
        <button
          (click)="goToSection()"
          class="hover:bg-gray-200 disabled:opacity-30 ml-1 disabled:hover:transform-none hover:scale-95 transition-transform btn-icon">
          @if (isGASection) {
            <img
              src="/assets/img/location-sharp-icon-disabled.svg"
              alt="location icon"
              class="cursor-not-allowed" />
          } @else {
            <img
              src="/assets/img/location-sharp-icon.svg"
              alt="location icon" />
          }
        </button>
        <button
          data-cy="cart-section-item-arrow-button"
          class="hover:bg-gray-200 disabled:opacity-20 ml-1 disabled:hover:transform-none hover:scale-95 transition-transform btn-icon"
          [ngClass]="this.showSeats ? 'rotate-0' : 'rotate-180'"
          #arrow
          (click)="toggleSeats()">
          <img
            src="/assets/img/arrow-down-blue-icon.svg"
            alt="blue downward arrow icon" />
        </button>
      </div>
    </div>

    <ng-container>
      @if (isTicketFeeEnabled && data.totalSectionPriceWithFee) {
        <div
          class="flex justify-between items-center bg-main-blue01 mb-2 p-2 rounded-xl text-main-blue text-xs">
          <div>
            <span class="mr-1">Price</span>
            <span class="mr-1 font-bold">
              ${{ data.totalSectionPrice | number: '1.2-2' }}</span
            >
            +
            <span class="mr-1">Fees</span>
            <span class="font-bold">
              ${{ data.totalFee | number: '1.2-2' }}</span
            >
          </div>
          <div class="font-bold">
            <span class="mr-1">Total:</span>
            <span> ${{ data.totalSectionPriceWithFee | number: '1.2-2' }}</span>
          </div>
        </div>
      }
    </ng-container>
  </div>
</div>
